import React, { useState } from 'react';
import axios from 'axios';
import { handleApiError, logError } from '../utils/errorHandler';
import { useLanguage } from '../contexts/LanguageContext';

function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { t } = useLanguage();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await axios.post(
        '/token',
        new URLSearchParams({ username, password }),
        {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        }
      );

      // Cookie wird vom Backend gesetzt, Seite neu laden damit App.js den User lädt
      window.location.href = '/admin/edit';

    } catch (err) {
      logError(err, 'Login');
      const errorMessage = handleApiError(err, 'Login fehlgeschlagen. Bitte Zugangsdaten prüfen.');
      setError(errorMessage);
      setLoading(false);
    }
  };

  return (
    <div className="card" style={{ maxWidth: 400, margin: '40px auto' }}>
      <h2>{t('adminLogin.title')}</h2>
      <form onSubmit={handleLogin}>
        <div className="form-group">
          <label>{t('adminLogin.username')}</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            autoComplete="username"
          />
        </div>
        <div className="form-group">
          <label>{t('adminLogin.password')}</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
          />
        </div>
        <button type="submit" disabled={loading}>
          {loading ? t('adminLogin.loading') : t('adminLogin.submit')}
        </button>
      </form>
      {error && <p style={{ color: 'salmon', marginTop: 10 }}>{error}</p>}
    </div>
  );
}

export default AdminLogin;
